/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type CorrectionUpsertRequest,
    CorrectionUpsertRequestFromJSON,
    CorrectionUpsertRequestToJSON,
} from '../models/CorrectionUpsertRequest';
import {
    type CorrectionUpsertResponse,
    CorrectionUpsertResponseFromJSON,
    CorrectionUpsertResponseToJSON,
} from '../models/CorrectionUpsertResponse';
import {
    type HTTPValidationError,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
} from '../models/HTTPValidationError';
import {
    type StatsResponse,
    StatsResponseFromJSON,
    StatsResponseToJSON,
} from '../models/StatsResponse';
import {
    type SubmissionGetRequest,
    SubmissionGetRequestFromJSON,
    SubmissionGetRequestToJSON,
} from '../models/SubmissionGetRequest';
import {
    type SubmissionGetResponse,
    SubmissionGetResponseFromJSON,
    SubmissionGetResponseToJSON,
} from '../models/SubmissionGetResponse';
import {
    type SubmissionListRequest,
    SubmissionListRequestFromJSON,
    SubmissionListRequestToJSON,
} from '../models/SubmissionListRequest';
import {
    type SubmissionListResponse,
    SubmissionListResponseFromJSON,
    SubmissionListResponseToJSON,
} from '../models/SubmissionListResponse';

export interface GetStatsRequest {
    /**
     * 
     */
    body: object;
    /**
     * 
     */
    accessToken?: string | null;
}

export interface GetSubmissionsRequest {
    /**
     * 
     */
    submissionGetRequest: SubmissionGetRequest;
    /**
     * 
     */
    accessToken?: string | null;
}

export interface ListSubmissionsRequest {
    /**
     * 
     */
    submissionListRequest: SubmissionListRequest;
    /**
     * 
     */
    accessToken?: string | null;
}

export interface UpsertCorrectionRequest {
    /**
     * 
     */
    correctionUpsertRequest: CorrectionUpsertRequest;
    /**
     * 
     */
    uploadToken?: string | null;
    /**
     * 
     */
    accessToken?: string | null;
}

/**
 * 
 */
export class SubmissionsApi extends runtime.BaseAPI {

    /**
     * Creates request options for getStats without sending the request
     */
    async getStatsRequestOpts(requestParameters: GetStatsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling getStats().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/submissions/stats`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        };
    }

    /**
     * Get Stats
     */
    async getStatsRaw(requestParameters: GetStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StatsResponse>> {
        const requestOptions = await this.getStatsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StatsResponseFromJSON(jsonValue));
    }

    /**
     * Get Stats
     */
    async getStats(requestParameters: GetStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StatsResponse> {
        const response = await this.getStatsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getSubmissions without sending the request
     */
    async getSubmissionsRequestOpts(requestParameters: GetSubmissionsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['submissionGetRequest'] == null) {
            throw new runtime.RequiredError(
                'submissionGetRequest',
                'Required parameter "submissionGetRequest" was null or undefined when calling getSubmissions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/submissions/get`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SubmissionGetRequestToJSON(requestParameters['submissionGetRequest']),
        };
    }

    /**
     * Get Submissions
     */
    async getSubmissionsRaw(requestParameters: GetSubmissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubmissionGetResponse>> {
        const requestOptions = await this.getSubmissionsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubmissionGetResponseFromJSON(jsonValue));
    }

    /**
     * Get Submissions
     */
    async getSubmissions(requestParameters: GetSubmissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubmissionGetResponse> {
        const response = await this.getSubmissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listSubmissions without sending the request
     */
    async listSubmissionsRequestOpts(requestParameters: ListSubmissionsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['submissionListRequest'] == null) {
            throw new runtime.RequiredError(
                'submissionListRequest',
                'Required parameter "submissionListRequest" was null or undefined when calling listSubmissions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/submissions/list`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SubmissionListRequestToJSON(requestParameters['submissionListRequest']),
        };
    }

    /**
     * List Submissions
     */
    async listSubmissionsRaw(requestParameters: ListSubmissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubmissionListResponse>> {
        const requestOptions = await this.listSubmissionsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubmissionListResponseFromJSON(jsonValue));
    }

    /**
     * List Submissions
     */
    async listSubmissions(requestParameters: ListSubmissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubmissionListResponse> {
        const response = await this.listSubmissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for upsertCorrection without sending the request
     */
    async upsertCorrectionRequestOpts(requestParameters: UpsertCorrectionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['correctionUpsertRequest'] == null) {
            throw new runtime.RequiredError(
                'correctionUpsertRequest',
                'Required parameter "correctionUpsertRequest" was null or undefined when calling upsertCorrection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/submissions/corrections/upsert`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CorrectionUpsertRequestToJSON(requestParameters['correctionUpsertRequest']),
        };
    }

    /**
     * A screen-entered correction (reqs 10-12): the uploader may correct their own fish, the team any fish. A new row every upsert — the latest FORM row is the current one; the history is kept.
     * Upsert Correction
     */
    async upsertCorrectionRaw(requestParameters: UpsertCorrectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CorrectionUpsertResponse>> {
        const requestOptions = await this.upsertCorrectionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CorrectionUpsertResponseFromJSON(jsonValue));
    }

    /**
     * A screen-entered correction (reqs 10-12): the uploader may correct their own fish, the team any fish. A new row every upsert — the latest FORM row is the current one; the history is kept.
     * Upsert Correction
     */
    async upsertCorrection(requestParameters: UpsertCorrectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CorrectionUpsertResponse> {
        const response = await this.upsertCorrectionRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
